import { IconProps } from './types';

export const ListenIcon = ({ title = 'Listen Icon', ...props }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="44" fill="none" viewBox="0 0 48 44" {...props}>
        <title>{title}</title>
        <path fill="#0A2F73" d="M24 11a5 5 0 0 0-5 5v10a5 5 0 0 0 10 0V16a5 5 0 0 0-5-5"></path>
        <path
            fill="#0A2F73"
            d="M17 24a1 1 0 1 0-2 0v2c0 4.633 3.5 8.448 8 8.945V42h-4a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2h-4v-7.055c4.5-.497 8-4.312 8-8.945v-2a1 1 0 1 0-2 0v2a7 7 0 1 1-14 0zM6 14a6 6 0 0 0-6 6v2a6 6 0 0 0 6 6zM42 28a6 6 0 0 0 6-6v-2a6 6 0 0 0-6-6z"
        ></path>
        <path
            fill="#FB0"
            d="M10.141 14.005C11.11 7.218 16.945 2 24 2s12.89 5.218 13.859 12.005A2 2 0 0 0 36 16v10a2 2 0 0 0 2 2h2V14h-.124C38.892 6.107 32.16 0 24 0 15.84 0 9.108 6.107 8.124 14H8v14h2a2 2 0 0 0 2-2V16a2 2 0 0 0-1.859-1.995"
        ></path>
    </svg>
);
